const BackIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 87 87">
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_5315"
            width="87"
            height="87"
            transform="translate(0 -0.5)"
            fill="#636363"
          />
        </clipPath>
      </defs>
      <g id="Mask_Group_673" data-name="Mask Group 673" transform="translate(86.5) rotate(90)">
        <g id="next_1_" transform="translate(83.819 21.297) rotate(90)">
          <g id="Group_44772" transform="translate(0 0)">
            <path
              id="Path_79510"
              d="M42.7,38.169,5.343.913A3.131,3.131,0,1,0,.921,5.347L36.056,40.385.92,75.423a3.131,3.131,0,0,0,4.422,4.433L42.7,42.6a3.129,3.129,0,0,0,0-4.433Z"
              fill="#b2b2b2"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default BackIcon;
